import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { InsuranceService } from '../../services/insurance/insurance.service';
import { AgentInsuranceDialogComponent } from '../agent-insurance-dialog/agent-insurance-dialog.component';
import { SearchTermservice } from '../../services/search/search-service.service';
import { InsuranceDoc } from '../../model/insurance.model';
import { forEach } from '@angular/router/src/utils/collection';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule, MatCheckboxModule, MatPaginatorIntl } from '@angular/material';
import { Sort } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { MatIconModule } from '@angular/material';
import { SortPipe } from '../../../shared/sortPipe';
import { PageEvent } from '@angular/material';
import { ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { InsuranceDocsClearDialogComponent } from '../insurance-docs-clear-dialog/insurance-docs-clear-dialog.component';
import { DownloadService } from '../../services/download/download.service';
import * as moment from 'moment';
import { DisableRow } from '../../../shared/globalService';
import { GetDocStatusColor } from '../../../shared/globalService';
import { PendingApprovalDialogComponent } from './../pending-approval-dialog/pending-approval-dialog.component';
import { ApproveRejectDialogComponent } from './../approve-reject-dialog/approve-reject-dialog.component';

@Component({
  selector: 'app-agent-insurance',
  templateUrl: './agent-insurance.component.html',
  styleUrls: ['./agent-insurance.component.css']
})
export class AgentInsuranceComponent implements OnInit {
  public documentsAllowedToUpload = [];
  doctype;
  agentName: string;
  agentId;
  agentDetails;
  pageSize = 10;
  insurancedocs = [];
  agentdoctype = [];
  clientDisable: any;
  clientHidden: any;
  public role: string;
  dataSource: MatTableDataSource<UserData>;
  displayedColumns = ['DocumentType', 'FileName', 'ExpirationDate', 'UploadedTimeStamp','DocumentStatus', 'FileEdit'];
  message: string;
  sortedData;
  data: boolean = true;
  docCategory: any;
  errorMessage: String = '';
  errorEnable: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  length: number;
  ispaginationFlag: boolean;
  noResults: string;
  vendorName: string;
  uploadedFileName: string;
  placeholder = "Select a Document";
  grey: boolean = false;
  approve_reject_button: boolean = false;
  disable_edit: boolean = false;

  constructor(private downloadservice: DownloadService,
              private http: Http,
              private searchTermservice: SearchTermservice,
              private router: Router,
              public dialog: MatDialog,
              private insuranceservice: InsuranceService,
              private disabletheRow: DisableRow,
              private getDocStatusColor: GetDocStatusColor) {
    this.insuranceservice.doctypeget().subscribe(res => {
      this.agentdoctype = res.DocumentTypes;
      this.docCategory = this.agentdoctype[0].Category;
      this.populateDocumentTypeDropDown();
    }, error => {
      this.errorMessage = "Vendor document types: " + error;
      this.errorEnable = true;
    });
  }

  pageEvent: PageEvent;

  ngOnInit() {
    this.vendorName = localStorage.getItem('AgentName');
    this.uploadedFileName = 'Vendor Insurance - ' + this.vendorName;
    this.insuranceservice.load.subscribe(res => {
      if (res === 'success') {
        this.doctype = null;
        this.getDetails();
      }
    }, error => {
    });

    this.getDetails();

    this.agentId = localStorage.getItem("AgentId");
    this.searchTermservice.detailsOfAgent(this.agentId).subscribe(res => {
      this.agentDetails = res;
      localStorage.setItem('AgentName', this.agentDetails.name)
    }, error => {
      this.errorMessage = "Vendor details: " + error;
      this.errorEnable = true;
    });

    this.role = localStorage.getItem("Role")
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }

  populateDocumentTypeDropDown() {
    const documentTypeFilter = () => true;
    this.documentsAllowedToUpload = this.filterDocumentTypesBy(documentTypeFilter);
  }

  filterDocumentTypesBy(filterDocumentsPredicate) {
    return this.agentdoctype.filter(filterDocumentsPredicate);
  }

  placeholderChange() {
    this.placeholder = "Document";
  }

  getDetails() {
    this.insuranceservice.insuranceDocGet(localStorage.getItem("AgentId")).subscribe(res => {
      if (res.VendorDocs.length <= 0 || res.VendorDocs == undefined) {
        this.insurancedocs = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.message = "No documents found";
      }
      else {
        this.message = '';
        this.data = true;
        this.insurancedocs = res.VendorDocs;
        for (let i = 0; i < this.insurancedocs.length; i++) {
          if (this.insurancedocs[i].UploadedTimeStamp !== "" && this.insurancedocs[i].UploadedTimeStamp != null && this.insurancedocs[i].UploadedTimeStamp != undefined) {
            var momentDate = moment(this.insurancedocs[i].UploadedTimeStamp).format('YYYY/MM/DD');
            this.insurancedocs[i].UploadedTimeStamp = momentDate;
          }
          if (this.insurancedocs[i].ExpirationDate !== '' && this.insurancedocs[i].ExpirationDate !== null && this.insurancedocs[i].ExpirationDate !== undefined) {
            var momentDate = moment(this.insurancedocs[i].ExpirationDate).format('YYYY/MM/DD');
            this.insurancedocs[i].ExpirationDate = momentDate;
          }
        }
        this.dataSource = new MatTableDataSource(this.insurancedocs);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.length = this.insurancedocs.length;
        if (this.length < 10) {
          this.ispaginationFlag = false;
        }
        else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, error => {
      this.errorMessage = "Vendor insurance documents: " + error;
      this.errorEnable = true;
    });
  }

  clear(data, type?) {
    data.DocumentCategory = this.docCategory;
    let dialogRef = this.dialog.open(InsuranceDocsClearDialogComponent, {
      width: '400px',
      height: '200px',
      data: { 'data': data, 'type': 'insurance' }
    });
  }

  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    } else if (expDate > future) {
      return "black";
    } else {
      return "blue";
    }
  }

  openDialog(name, type, id?): void {
    let code = null;
    code = this.agentdoctype.find(doc => doc.DocumentTypeName === name).DocumentTypeCode;
    var new_Data = {
      MasterVendorId: localStorage.getItem('AgentId'),
      DocumentType: name,
      VendorInsuranceId: id,
      DocumentTypeCode: code,
      DocumentCategory: this.docCategory
    };
    var Data;
    if (this.insurancedocs.length > 0) {
      for (let i = 0; i < this.insurancedocs.length; i++) {
        if (this.insurancedocs[i].VendorInsuranceId === id) {
          Data = this.insurancedocs[i]
        }
      }
    }
    let dialogRef = this.dialog.open(AgentInsuranceDialogComponent, {
      width: '1000px',
      height: '600px',
      data: { data: type === 'update' ? Data : new_Data, type: type, category: this.docCategory }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.doctype = null;
      this.placeholder = "Select a Document";
    });
  }

  doctypechange(doc) {
    this.openDialog(doc, 'create');
  }

  fileEdit(docName, id, vendorinsuranceid, docDetails) {
    localStorage.setItem('oldVendorInsuranceFileName', JSON.stringify(docDetails.FileName));
    if (docDetails.DocumentStatus === "Pending Approval" && (this.role === "PC Site Admin" || this.role === "PC PAR Admin" || this.role === "PC PAR Vendor Relations")) {
      this.validateDoc(docDetails, 'update');
    } else {
      this.openDialog(docName, 'update', id);
    }
  }

  validateDoc(insuranceDetails, type): void {
    insuranceDetails.DocumentCategory = this.docCategory;

    var new_Data = {
      AGENT_ID: localStorage.getItem('AgentId'),
      DocumentTypeName: insuranceDetails.DocumentType,
      DocumentTypeCode: insuranceDetails.DocumentTypeCode,
      DocumentCategory: insuranceDetails.DocumentCategory
    };

    this.clientHidden = false;
    let dialogRef = this.dialog.open(PendingApprovalDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: type === 'update' ? insuranceDetails : new_Data, type: type, pagename: 'insurance' }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  // Greyout the row if the ststus is in inprogress
  disableRow(status, updatedBy) {
    let response = this.disabletheRow.disableRow(status, updatedBy);
    this.grey = response['Disable'];
    this.disable_edit = response['Disable_Edit'];
    return response.CSS;
  }

  // Get the status color
  getStatusColor(status, updatedBy) {
    let response = this.getDocStatusColor.getStatusColor(status, updatedBy);
    this.approve_reject_button = response['Approve/Reject Button'];
    return response.CSS;
  }

  doApproveRejectDialog(insuranceDetails, type): void {
    insuranceDetails.DocumentCategory = this.docCategory;

    var new_Data = {
      AGENT_ID: localStorage.getItem('AgentId'),
      DocumentTypeName: insuranceDetails.DocumentType,
      DocumentTypeCode: insuranceDetails.DocumentTypeCode,
      DocumentCategory: insuranceDetails.DocumentCategory
    };
    var Data;

    this.clientHidden = false;
    let dialogRef = this.dialog.open(ApproveRejectDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: type === 'update' ? insuranceDetails : new_Data, type: type, pagename: 'insurance' }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  doApproveReject(docName) {
    this.doApproveRejectDialog(docName, 'update');
  }
}

export interface UserData {
  DocumentType: String;
  FileName: String;
  ExpirationDate: Date;
  UploadedTimeStamp: Date;
  DocumentStatus:String;
  FileEdit: any;
}



// WEBPACK FOOTER //
// ./src/app/components/agent-insurance/agent-insurance.component.ts